import(/* webpackMode: "eager" */ "/codebuild/output/src3140639688/src/ispai/frontend/src/app/login/page.tsx");
